import { render } from "./PublicationMeta.vue?vue&type=template&id=05f57b9d&scoped=true"
import script from "./PublicationMeta.vue?vue&type=script&lang=js"
export * from "./PublicationMeta.vue?vue&type=script&lang=js"

import "./PublicationMeta.vue?vue&type=style&index=0&id=05f57b9d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f57b9d"]])

export default __exports__